export default [
    {
        title: "Control Bines",
        fontIcon: "dumpster",
        resource: "Control Bines",
        action: "ver-control-bines",
        children: [
            {
                route: "control-bines-resumen",
                title: "Dashboard",
                icon: "LayoutIcon",
                resource: "Control Bines",
                action: "ver-control-bines-dashboard"
            },
            {
                title: "Configuracion",
                icon: "SettingsIcon",
                resource: "Control Bines",
                action: "ver-control-bines-configuracion"
            },
            {
                title: "Mantenimiento",
                icon: "EditIcon",
                resource: "Control Bines",
                action: "ver-control-bines-mantenimiento"
            },
            {
                title: "Transacciones",
                fontIcon: "exchange-alt",
                resource: "Control Bines",
                action: "ver-control-bines-transacciones",
                children: [
                    {
                        route: "control-bines-despacho-pesca",
                        title: "Despacho Pesca",
                        resource: "Control Bines",
                        action: "ver-control-bines-despacho-pesca"
                    },
                    {
                        route: "control-bines-desgramos",
                        title: "Despacho de gramos",
                        resource: "Control Bines",
                        action: "ver-control-bines-desgramos"
                    },
                    {
                        route: "control-bines-guiavirtual",
                        title: "Creación de Guías virtuales",
                        resource: "Control Bines",
                        action: "ver-control-bines-guiavirtual"
                    }
                ]
            },
            {
                title: "Informes",
                fontIcon: "file-prescription",
                resource: "Control Bines",
                action: "ver-control-bines-informes",
                children: [
                    {
                        route: "control-bines-reportes",
                        title: "Reportes",
                        resource: "Control Bines",
                        action: "ver-control-bines-reportes"
                    },
                    {
                        route: "control-bines-monitoreo-movimientos",
                        title: "Monitoreo Movimientos",
                        resource: "Control Bines",
                        action: "ver-control-bines-monitoreo-movimientos"
                    },
                    {
                        route: "control-bines-consulta-plan-pesca",
                        title: "Histórico planificación",
                        resource: "Control Bines",
                        action: "ver-control-bines-consulta-plan-pesca"
                    },
                    {
                        route: "control-bines-estado-guias",
                        title: "Estado Guias",
                        resource: "Control Bines",
                        action: "ver-control-bines-estado-guias"
                    },
                    {
                        route: "control-bines-guia-virtual",
                        title: "Guías virtuales",
                        resource: "Control Bines",
                        action: "ver-control-bines-guia-virtual"
                    },
                    {
                        route: "control-bines-informes-historico-guias",
                        title: "Histórico Guías",
                        resource: "Control Bines",
                        action: "ver-control-bines-informes-historico-guias"
                    }
                ]
            }
        ]
    }
];


 
